import { types } from 'mobx-state-tree';
import moment from 'moment';

export const BaseEntity = types.model('BaseEntity', {
  createdOn: types.optional(types.string, moment().format()),
  createdBy: types.maybe(types.string),
  lastModifiedOn: types.optional(types.string, moment().format()),
  lastModifiedBy: types.maybe(types.string),
});
